/** 
import { Link, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const Header = () => {
  const user = authService.getCurrentUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/dashboard" className="font-bold text-xl text-indigo-600">
          🗑️ CleanCity
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          {user && (
            <>
              <span className="text-gray-600">
                Hello, <span className="font-semibold">{user.name}</span>
                {user.role === 'admin' && ' (Admin)'}
              </span>
              <Link
                to="/complaint/new"
                className="px-3 py-1 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
              >
                New Complaint
              </Link>
              {user.role === 'admin' && (
                <Link
                  to="/admin"
                  className="px-3 py-1 bg-purple-600 text-white rounded-md hover:bg-purple-700"
                >
                  Admin
                </Link>
              )}
              <button
                onClick={handleLogout}
                className="px-3 py-1 bg-gray-100 rounded-md hover:bg-gray-200"
              >
                Logout
              </button>
            </>
          )}
          {!user && (
            <>
              <Link to="/login" className="text-indigo-600">
                Login
              </Link>
              <Link to="/register" className="text-gray-600">
                Register
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
**/

import { Link, NavLink, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const Header = () => {
  const user = authService.getCurrentUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const navLinkClasses = ({ isActive }) =>
    `px-3 py-1 rounded-full text-xs sm:text-sm transition ${
      isActive
        ? 'bg-white text-indigo-700 shadow-sm'
        : 'text-indigo-100 hover:bg-indigo-500/40'
    }`;

  return (
    <header className="bg-gradient-to-r from-indigo-700 via-indigo-600 to-purple-600 shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        {/* Brand */}
        <Link to="/dashboard" className="flex items-center gap-2">
          <div className="h-8 w-8 flex items-center justify-center rounded-xl bg-white/10 border border-white/20">
            <span className="text-lg">🗑️</span>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-white font-semibold text-base sm:text-lg">
              CleanCity
            </span>
            <span className="text-indigo-100 text-[10px] sm:text-xs">
              Smart Garbage Reporting
            </span>
          </div>
        </Link>

        {/* Right side */}
        <div className="flex items-center gap-3">
          {user && (
            <div className="hidden sm:flex flex-col text-right text-xs text-indigo-100">
              <span className="font-medium">
                {user.name}{' '}
                {user.role === 'admin' && (
                  <span className="ml-1 text-[10px] px-1 py-0.5 rounded-full bg-white/10 border border-white/20">
                    Admin
                  </span>
                )}
              </span>
              <span className="opacity-80">{user.email}</span>
            </div>
          )}

          <nav className="flex items-center gap-1 sm:gap-2">
            {user ? (
              <>
                <NavLink to="/dashboard" className={navLinkClasses}>
                  My Complaints
                </NavLink>
                <NavLink to="/complaint/new" className={navLinkClasses}>
                  New Complaint
                </NavLink>
                {user.role === 'admin' && (
                  <NavLink to="/admin" className={navLinkClasses}>
                    Admin
                  </NavLink>
                )}
                <button
                  onClick={handleLogout}
                  className="px-3 py-1 rounded-full text-xs sm:text-sm bg-white/10 text-indigo-50 border border-white/20 hover:bg-white/20 transition"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <NavLink to="/login" className={navLinkClasses}>
                  Login
                </NavLink>
                <NavLink to="/register" className={navLinkClasses}>
                  Register
                </NavLink>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
